<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                                 type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="退款单号" name="refund_number"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
                    <c-form-item type="input" label="商户订单号" name="payment_number"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <!-- <c-form-item type="input" label="收货信息" name="receiving_info" placeholder="收件人、电话、地址"></c-form-item> -->
                    <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="state" :options="refundState"></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow power="b_order_refund_export"  @click="syncExport(1)">导出未发退款单</c-button>
                <c-button color="m" hollow power="b_order_refund_export"  @click="syncExport(2)">导出未发退款单明细</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(detailWorkType)">编辑明细导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="85"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.state==1">{{orderStateName[data.state]}}</span>
						<span style="color:darkgreen" v-if="data.state==2">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==3">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==4">{{orderStateName[data.state]}}</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="退款状态"
                        name="refund_state"
                        width="85"
                >
                    <template v-slot="{data}">
                        <span style="color:red" v-if="data.state==2 && data.refund_state==1">待退款</span>
                        <span style="color:brown" v-else-if="data.state==2 && data.refund_state==2">退款中</span>
                        <span style="color:green" v-else-if="data.state==2 && data.refund_state==3">已退款</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
				
				<c-table-column
					label="退款单号"
					name="refund_number"
					width="130"
				></c-table-column>

				<c-table-column
					label="退款类型"
					name="refund_type"
					width="80"
				>
				  <template v-slot="{data}">
					<span v-if="data.refund_type==1" style="color:#888888">{{refundTypeName[data.refund_type]}}</span>
					<span v-if="data.refund_type==2" style="color:#ff00ff">{{refundTypeName[data.refund_type]}}</span>
					<span v-if="data.refund_type==3" style="color:#000000">{{refundTypeName[data.refund_type]}}</span>
                    <span v-if="data.refund_type==4" style="color:#0086b3">{{refundTypeName[data.refund_type]}}</span>
				  </template>
				</c-table-column>
		
				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						{{operationModeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="120"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>
				
				<c-table-column
					label="订单号"
					name="order_number"
				  width="120"
				></c-table-column>

				<c-table-column
					label="商户订单号"
					name="payment_number"
				  width="120"
				></c-table-column>

				<c-table-column
					label="推送状态"
					name="push_state"
					width="80"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0"><span style="color:#bbbbbb">无需推送</span></span>
						<span v-if="data.push_state==1"><span style="color:#182eff">待推送</span></span>
						<span v-if="data.push_state==2"><span style="color:darkgreen">已推送</span></span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="售后三方单号"
					name="out_refund_number"
					width="140"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0">--</span>
						<span v-if="data.push_state==1">--</span>
						<span v-if="data.push_state==2">{{data.out_refund_number}}</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="120"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>
		
				<!-- <c-table-column
					label="收件信息"
					name="receiving_info"
				  width="200"
				>
                    <template v-slot="{data}">
                        <span>{{data.receiving_name}}</span>
                        <span v-if="data.receiving_phone"> ; {{data.receiving_phone}}</span>
                        <span v-if="data.receiving_address">({{data.receiving_address}})</span>
                    </template>
                </c-table-column> -->
		
				<!-- <c-table-column
					label="退款服务数量"
					name="product_count"
				    width="110"
				></c-table-column> -->
				
				<c-table-column
					label="退款服务金额"
					name="product_money"
                    width="110"
                >
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.product_money&&data.product_money>0">￥{{data.product_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<!-- <c-table-column
					label="运费退款"
					name="logistics_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.logistics_money&&data.logistics_money>0">￥{{data.logistics_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column> -->

				<!-- <c-table-column
					label="服务费退款"
					name="other_fee"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.other_fee&&data.other_fee>0">￥{{data.other_fee.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column> -->

				<c-table-column
					label="退款总额"
					name="refund_total_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.refund_total_money&&data.refund_total_money>0">￥{{data.refund_total_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
				    width="150"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
                    width="80"
                >
					<template v-slot="{data}">
						<c-table-button @click="navigateTo({path: `/refund_detail/${data.refund_number}`, query: {refundType: data.refund_type}})">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_order_refund',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
        props: {
            state: String,
            refund_state: String,

        },

		data() {
			return {
                workType:18,
                detailWorkType:19,
                searchParams:{},
				orderStateName: {
					1: '待审核',
					2: '审核通过',
					3: '已驳回',
					4: '已撤销'
				},
				operationModeName: {
                    1: '平台自营',
                    2: '商家自营'
				},
                operationMode: [
                    {name: '平台自营',value: 1},
                    {name: '商家自营',value: 2}
                ],
				refundState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '已驳回',
						value: 3
					},{
						name: '已撤销',
						value: 4
					}
				],
                refundTypeName: {
                  1: '整单取消',
                  2: '部分退款',
                  3: '定金退款',
                  4: '纠纷退款'
                }
			}
		},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
			
            defaultSearch() {
                let param = {
                    state: this.state ? this.state.split(',') : [],
                }

                if (this.refund_state == 1) {
                    param.start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('refund.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/refund/list',
					data
				});
                this.searchParams = data||{};
            },
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(type){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: type==1?this.workType:this.detailWorkType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>